import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Section } from 'formlabs-web-components/Grid';
import { Picture } from 'formlabs-web-components/Media';
import { Header } from 'formlabs-web-components/Type';
import { Eyebrow } from 'formlabs-web-components/Type';
import { Button } from 'formlabs-web-components/Link';
import CenterModal from '../../../../common/components/modal/CenterModal';

import './MaterialSelector.module.css';

const Material = ({
  name,
  industryName,
  materialType,
  tags,
  image,
  description,
  elongation,
  hardness,
  link,
  sampleLink
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const handleOpen = e => {
    e.preventDefault();
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <li styleName="material">
      <button styleName="materialCard" onClick={handleOpen}>
        <div styleName="image">
          <Picture
            alt={name}
            lazyload={false}
            largeImage={image}
            fullBleed={true}
          />
        </div>
        <div styleName="card-content">
          <p styleName="material-title">
            {name}
            {industryName && <span styleName="subtitle">{industryName}</span>}
          </p>
          <i className="fl-arrow-right" styleName="blue" />
        </div>
      </button>
      {open ? (
        <CenterModal noPadding onClose={handleClose} width="480px">
          <div styleName="modalImageContainer">
            <Picture largeImage={image} width="100%" alt={name} />
            <div styleName="modalTitle">
              <Header level={3} displayAs={4}>
                {name}
              </Header>
            </div>
          </div>
          <Section
            paddingSmall="1rem 2.5rem"
            paddingMedium="1rem 2.5rem"
            padding="1rem 2.5rem"
          >
            <div styleName="modalCtas">
              <Button url={link} arrow="none" color="dark">
                {t('Buy Now')}
              </Button>{' '}
              {sampleLink && (
                <Button url={sampleLink} arrow="none" color="light">
                  {t('Request a Sample')}
                </Button>
              )}
            </div>
            <Eyebrow color="black">{t('Description')}</Eyebrow>
            <div
              styleName="modalDescription"
              dangerouslySetInnerHTML={{ __html: description }}
            />
          </Section>
        </CenterModal>
      ) : null}
    </li>
  );
};

export default Material;
